export default {
  tipoOperadorLogico: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  tipoValidacao: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  pciModeloItem: {
    value: null,
    options: []
  },
  pciModeloItemID: {
    value: null,
    required: false,
    state: null
  },
  pciItemFixo: {
    parents: null,
    value: null,
    options: [
      { code: 10, text: 'IDENTIFICAÇÃO' },
      { code: 11, text: 'Detentora' },
      { code: 20, text: 'LOCALIZAÇÃO' },
      { code: 21, text: 'Cidade' },
      { code: 22, text: 'UF' },
      { code: 23, text: 'Tipo' },
      { code: 30, text: 'ACOMPANHAMENTO DE OBRA' },
      { code: 31, text: 'Prev. Início' },
      { code: 32, text: 'Início Real' },
      { code: 33, text: 'Prev. Término' },
      { code: 34, text: 'Término Real' },
      { code: 35, text: 'Prazo' },
      { code: 36, text: 'Dias Parados' },
      { code: 37, text: 'Prazo Real' },
      { code: 40, text: 'EQUIPE' },
      { code: 41, text: 'Coordenador' },
      { code: 42, text: 'Técnico' },
      { code: 43, text: 'Mestre de Obras' },
      { code: 50, text: 'ANÁLISE TÉCNICA' },
      { code: 51, text: 'Status' },
      { code: 52, text: 'Última Atualiz.' },
      { code: 60, text: 'AVALIAÇÃO' },
      { code: 61, text: 'Status' },
      { code: 62, text: 'Liberação' },
      { code: 63, text: 'Rejeição' },
      { code: 64, text: 'Autorização' },
      { code: 65, text: 'Conclusão' }
    ],
    required: false,
    stateu: null
  },
  constante: {
    value: null,
    required: false,
    state: null,
    maxlength: 50
  },
  pciModeloItemComparar: {
    value: null,
    options: []
  },
  pciModeloItemIDComparar: {
    value: null,
    required: false,
    state: null
  },
  tolerancia: {
    value: 0,
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/pci/items/addValidationAutomation-form.js